module.exports = __webpack_public_path__ + "img/az_get.3d2fa5d.png";